import { Modal, ModalProps } from "antd";
import { useState } from "react";
import "../../styles/modalAnimations.css";
import { useOverlayKeyboardLock } from "../hooks/useOverlayKeyboardLock";

interface StaticModalProps extends ModalProps {
  children?: React.ReactNode;
}

/**
 * Static Modal - Cannot close by clicking outside, but supports Esc by default
 * Shows bounce animation when user tries to close via mask click
 */
export const StaticModal = ({ children, ...props }: StaticModalProps) => {
  const [isBouncing, setIsBouncing] = useState(false);
  const keyboardLockRef = useOverlayKeyboardLock(Boolean(props.open));

  const handleMaskClick = (e: React.MouseEvent) => {
    // Check if click is on the mask (outside the modal)
    if ((e.target as HTMLElement).classList.contains("ant-modal-mask")) {
      setIsBouncing(true);
      // Remove animation class after animation completes
      setTimeout(() => setIsBouncing(false), 500);
    }
  };

  return (
    <div
      onClick={handleMaskClick}
      className={isBouncing ? "modal-bounce" : ""}
    >
      <Modal
        {...props}
        rootClassName={`static-overlay-modal${props.rootClassName ? ` ${props.rootClassName}` : ""}`}
        maskClosable={false}
        keyboard={props.keyboard ?? false}
        styles={{
          ...props.styles,
          content: { background: "var(--elevated-bg)", ...props.styles?.content },
          header: { background: "var(--elevated-bg)", ...props.styles?.header },
          body: { background: "var(--elevated-bg)", ...props.styles?.body },
          footer: { background: "var(--elevated-bg)", ...props.styles?.footer }
        }}
        modalRender={(node) => (
          <div
            ref={keyboardLockRef}
            tabIndex={-1}
            data-overlay-keyboard-lock="modal"
          >
            {props.modalRender ? props.modalRender(node) : node}
          </div>
        )}
      >
        {children}
      </Modal>
    </div>
  );
};
